import { render, staticRenderFns } from "./HelperTagDetails.vue?vue&type=template&id=507be232&scoped=true"
import script from "./HelperTagDetails.vue?vue&type=script&lang=js"
export * from "./HelperTagDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507be232",
  null
  
)

export default component.exports